import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareTimelineClassicRoute: InvariantJiraRoute = {
	name: 'software-timeline-classic',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/timeline',
};
